import React from 'react';
import { AnimatedShinyText } from './AnimatedShinyText';
const Header = () => {
  return <header className="text-center mb-12 md:mb-24" data-id="element-35">
      <div className="inline-block mb-6 md:mb-8" data-id="element-36">
        <div className="border-b-2 border-green-500/30 pb-2" data-id="element-37">
          <div className="mb-3 md:mb-4" data-id="element-38">
            <AnimatedShinyText className="inline-flex items-center justify-center px-3 md:px-4 py-1 md:py-1.5 text-base md:text-lg font-medium border border-green-500/30 rounded-full" data-id="element-39">
              <span className="flex items-center gap-2" data-id="element-40">
                <span className="w-1.5 md:w-2 h-1.5 md:h-2 rounded-full bg-green-500 animate-pulse" data-id="element-41" />
                Now accepting new guests
              </span>
            </AnimatedShinyText>
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-1 md:mb-2 tracking-tight" data-id="element-42">
            <span className="bg-gradient-to-r from-green-500 to-emerald-400 text-transparent bg-clip-text" data-id="element-43">
              The Deal Flow Show
            </span>
          </h1>
          <h2 className="text-3xl sm:text-4xl md:text-8xl font-bold text-white/90" data-id="element-44">
            Hall of Fame
          </h2>
        </div>
      </div>
      <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-2 md:mb-3 px-4 md:px-0" data-id="element-45">
        A prestigious collection of visionaries, innovators, and industry titans
        who have graced our show with their unparalleled wisdom and
        extraordinary achievements.
      </p>
      <p className="text-xs md:text-sm italic text-green-400/80 max-w-3xl mx-auto px-4 md:px-0" data-id="element-46">
        Members of the Deal Flow Show Hall of Fame have exclusive access to
        private events and our private network of founders, investors, &
        executives.
      </p>
    </header>;
};
export default Header;